/* eslint-disable */
import React from 'react';
import MarkerLayer from 'react-leaflet-marker-layer';

class ProjectsLayer extends React.Component {

  static propTypes = {
    latitudeExtractor: React.PropTypes.func.isRequired,
    longitudeExtractor: React.PropTypes.func.isRequired,
    map: React.PropTypes.object.isRequired,
    points: React.PropTypes.array.isRequired,
  };

  state = {
    mapHidden: false,
    layerHidden: false,
    markers: this.props.points,
    msg: null
  };

  _moveMarker() {
    setTimeout(() => {
      m.location[1] 
      markers[0].position.lng = markers[0].position.lng + 2;
      this.setState({ markers: Array.from(markers) });
    }, 1000 * 1);
  }

  componentDidMount() {
    //this._moveMarker();
    setTimeout(() => {
    }, 1000 * 5);
  }

  render() {

    const style = {
      border: 'solid 1px lightblue',
      backgroundColor: '#e34a33',
      borderRadius: '50%',
      marginTop: '-12px',
      marginLeft: '-12px',
      width: '14px',
      height: '14px'
    };

    return (
      <div style={Object.assign({}, this.props.style, style)}>
       <MarkerLayer
        map = {this.props.map}
        markers={this.props.points}
        longitudeExtractor={m => m.location[1]}
        latitudeExtractor={m => m.location[0]}
        markerComponent={ProjectsLayer}/>
      </div>
    );
}
}

export default ProjectsLayer;


/** WEBPACK FOOTER **
 ** ./app/scripts/components/map/projectslayer.jsx
 **/